import { Textarea } from '@creanizer/ui'
import { Label } from '@creanizer/ui'

interface TextInputProps {
  value: string
  onChange: (value: string) => void
  charCount: number
}

export function TextInput({ value, onChange, charCount }: TextInputProps) {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label htmlFor="text-input">テキスト入力</Label>
        <span className="text-sm text-muted-foreground">
          {charCount.toLocaleString()}文字
        </span>
      </div>
      <Textarea
        id="text-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="要約したいテキストを入力してください..."
        className="min-h-[300px] font-mono text-sm"
      />
      {charCount > 1000000 && (
        <p className="text-sm text-amber-600">
          注意: 100万文字を超えるテキストは処理に時間がかかる場合があります
        </p>
      )}
    </div>
  )
}